export default __webpack_public_path__ + "media/images/images/pages/windows-type-scale-4f6053934698f1e4228c3f052ff16ca0.png";